import Constants from "../utils/consts";

var http = require("follow-redirects").https;
var qs = require("querystring");

/**
 * Chiama l'API per aggiornare lo stato iscritto di un contatto
 * @param {string} uname - Username dell'utente
 * @param {string} token - Token di autenticazione
 * @param {string} email - Email del contatto da aggiornare
 * @param {boolean} iscritto - Stato iscritto (default: true)
 * @param {number} idCorso - ID del corso di appartenenza (opzionale)
 * @returns {Promise} - Promessa che risolve con la risposta dell'API
 */
export default async function aggiornaIscritto(
  uname,
  token,
  email,
  iscritto = true,
  idCorso = null
) {
  return new Promise(function(resolve, reject) {
    var options = {
      method: "POST",
      hostname: Constants.ipAddress,
      path: Constants.apisFolder + "aggiornaIscritto.php", // Fix: usa il path corretto come le altre API
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
        Cookie: "uid=e02675a1a7516909792f6850dffcd5fe", // Usa Cookie come le altre API
      },
      maxRedirects: 20,
    };

    var req = http.request(options, function(res) {
      var chunks = [];

      res.on("data", function(chunk) {
        chunks.push(chunk);
      });

      res.on("end", function(chunk) {
        var body = Buffer.concat(chunks);

        try {
          const response = JSON.parse(body.toString());

          if (response.success) {
            resolve(response);
          } else {
            reject(
              new Error(
                response.error || "Errore sconosciuto nell'aggiornamento"
              )
            );
          }
        } catch (error) {
          reject(
            new Error("Errore nel parsing della risposta: " + error.message)
          );
        }
      });

      res.on("error", function(error) {
        console.error("Errore nella richiesta:", error);
        reject(error);
      });
    });

    var postData = qs.stringify({
      token: token,
      uname: uname,
      email: email,
      iscritto: iscritto ? 1 : 0,
      id_corso: idCorso || "",
    });

    req.write(postData);

    req.end();
  });
}
